import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';

const Reports = () => {
    const [selectedPeriod, setSelectedPeriod] = useState('month');

    const reports = [
        {
            id: 'financial',
            title: 'Raport Financiar',
            description: 'Venituri, cheltuieli și profitabilitate',
            lastGenerated: '2025-01-15 14:30',
            status: 'available'
        },
        {
            id: 'appointments',
            title: 'Raport Programări',
            description: 'Statistici privind programările și ocuparea doctorilor',
            lastGenerated: '2025-01-15 12:00',
            status: 'available'
        },
        {
            id: 'patients',
            title: 'Raport Pacienți',
            description: 'Analiza demografică și frecvența vizitelor',
            lastGenerated: '2025-01-14 16:45',
            status: 'available'
        },
        {
            id: 'performance',
            title: 'Raport Performanță',
            description: 'Indicatori de eficiență și calitate a serviciilor',
            lastGenerated: '2025-01-13 10:15',
            status: 'processing'
        }
    ];

    return (
        <div className="reports-page">
            <div className="page-navigation-header">
                <div className="nav-header-content">
                    <NavLink to="/dashboard" className="back-to-dashboard">
                        ← Înapoi la Dashboard
                    </NavLink>
                    <div className="quick-nav">
                        <NavLink to="/patients" className={({ isActive }) => isActive ? "quick-nav-link active" : "quick-nav-link"}>
                            Pacienți
                        </NavLink>
                        <NavLink to="/appointments" className={({ isActive }) => isActive ? "quick-nav-link active" : "quick-nav-link"}>
                            Programări
                        </NavLink>
                        <NavLink to="/doctors" className={({ isActive }) => isActive ? "quick-nav-link active" : "quick-nav-link"}>
                            Doctori
                        </NavLink>
                    </div>
                </div>
            </div>

            <div className="page-header">
                <h1>Rapoarte și Statistici</h1>
                <p>Generarea și vizualizarea rapoartelor medicale și administrative</p>
            </div>

            <div className="reports-controls">
                <div className="control-group">
                    <label htmlFor="period-select">Perioadă:</label>
                    <select
                        id="period-select"
                        value={selectedPeriod}
                        onChange={(e) => setSelectedPeriod(e.target.value)}
                        className="period-select"
                    >
                        <option value="week">Săptămână</option>
                        <option value="month">Lună</option>
                        <option value="quarter">Trimestru</option>
                        <option value="year">An</option>
                        <option value="custom">Personalizat</option>
                    </select>
                </div>

                {selectedPeriod === 'custom' && (
                    <div className="custom-date-range">
                        <div className="date-group">
                            <label>Data început:</label>
                            <input type="date" className="date-input" />
                        </div>
                        <div className="date-group">
                            <label>Data sfârșit:</label>
                            <input type="date" className="date-input" />
                        </div>
                    </div>
                )}

                <button className="generate-report-btn">Generează Raport Nou</button>
            </div>

            <div className="reports-grid">
                {reports.map(report => (
                    <div key={report.id} className={`report-card ${report.status}`}>
                        <div className="report-header">
                            <h3>{report.title}</h3>
                            <span className={`status-badge ${report.status}`}>
                                {report.status === 'available' ? 'Disponibil' :
                                    report.status === 'processing' ? 'În Procesare' :
                                        'Indisponibil'}
                            </span>
                        </div>
                        <p className="report-description">{report.description}</p>
                        <div className="report-meta">
                            <small>Ultima generare: {new Date(report.lastGenerated).toLocaleString('ro-RO')}</small>
                        </div>
                        <div className="report-actions">
                            {report.status === 'available' ? (
                                <>
                                    <button className="download-btn">Descarcă</button>
                                    <button className="view-btn">Vezi Online</button>
                                </>
                            ) : (
                                <button className="refresh-btn" disabled>Se Procesează...</button>
                            )}
                        </div>
                    </div>
                ))}
            </div>

            <div className="reports-summary">
                <h2>Rezumat Statistici</h2>
                <div className="summary-grid">
                    <div className="summary-card">
                        <h4>Pacienți Luna Aceasta</h4>
                        <div className="summary-number">1,247</div>
                        <span className="summary-change positive">+12% față de luna trecută</span>
                    </div>
                    <div className="summary-card">
                        <h4>Programări Efectuate</h4>
                        <div className="summary-number">892</div>
                        <span className="summary-change positive">+18% față de luna trecută</span>
                    </div>
                    <div className="summary-card">
                        <h4>Rată Dezabonare</h4>
                        <div className="summary-number">2.4%</div>
                        <span className="summary-change negative">+0.2% față de luna trecută</span>
                    </div>
                    <div className="summary-card">
                        <h4>Venit Mediu per Pacient</h4>
                        <div className="summary-number">€127</div>
                        <span className="summary-change positive">+5% față de luna trecută</span>
                    </div>
                </div>
            </div>

            <style jsx>{`
                .reports-page {
                    max-width: 1200px;
                    margin: 0 auto;
                    padding: 2rem;
                }

                .page-header {
                    margin-bottom: 2rem;
                }

                .page-header h1 {
                    color: #333;
                    margin-bottom: 0.5rem;
                }

                .page-header p {
                    color: #666;
                }

                .reports-controls {
                    background: white;
                    padding: 1.5rem;
                    border-radius: 8px;
                    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
                    margin-bottom: 2rem;
                    display: flex;
                    flex-wrap: wrap;
                    gap: 1rem;
                    align-items: center;
                }

                .control-group {
                    display: flex;
                    align-items: center;
                    gap: 0.5rem;
                }

                .control-group label {
                    font-weight: 500;
                    color: #333;
                }

                .period-select {
                    padding: 0.5rem;
                    border: 1px solid #ddd;
                    border-radius: 4px;
                    font-size: 1rem;
                }

                .custom-date-range {
                    display: flex;
                    gap: 1rem;
                }

                .date-group {
                    display: flex;
                    flex-direction: column;
                    gap: 0.25rem;
                }

                .date-group label {
                    font-size: 0.9rem;
                    color: #666;
                }

                .date-input {
                    padding: 0.5rem;
                    border: 1px solid #ddd;
                    border-radius: 4px;
                }

                .generate-report-btn {
                    padding: 0.75rem 1.5rem;
                    background: #667eea;
                    color: white;
                    border: none;
                    border-radius: 4px;
                    cursor: pointer;
                    font-weight: 500;
                    transition: background 0.3s;
                }

                .generate-report-btn:hover {
                    background: #5a67d8;
                }

                .reports-grid {
                    display: grid;
                    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
                    gap: 1.5rem;
                    margin-bottom: 3rem;
                }

                .report-card {
                    background: white;
                    border-radius: 8px;
                    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
                    padding: 1.5rem;
                    border-left: 4px solid #667eea;
                    opacity: 1;
                }

                .report-card.processing {
                    opacity: 0.7;
                }

                .report-header {
                    display: flex;
                    justify-content: space-between;
                    align-items: flex-start;
                    margin-bottom: 0.5rem;
                }

                .report-header h3 {
                    margin: 0;
                    color: #333;
                    font-size: 1.2rem;
                }

                .status-badge {
                    padding: 0.25rem 0.75rem;
                    border-radius: 4px;
                    font-size: 0.8rem;
                    font-weight: 600;
                    text-transform: uppercase;
                }

                .status-badge.available {
                    background: #d4edda;
                    color: #155724;
                }

                .status-badge.processing {
                    background: #fff3cd;
                    color: #856404;
                }

                .report-description {
                    color: #666;
                    margin-bottom: 1rem;
                    font-size: 0.9rem;
                }

                .report-meta {
                    margin-bottom: 1rem;
                }

                .report-meta small {
                    color: #999;
                }

                .report-actions {
                    display: flex;
                    gap: 0.5rem;
                }

                .download-btn,
                .view-btn,
                .refresh-btn {
                    padding: 0.5rem 1rem;
                    border: none;
                    border-radius: 4px;
                    cursor: pointer;
                    font-weight: 500;
                    font-size: 0.9rem;
                    transition: background 0.3s;
                }

                .download-btn {
                    background: #28a745;
                    color: white;
                }

                .download-btn:hover {
                    background: #218838;
                }

                .view-btn {
                    background: #17a2b8;
                    color: white;
                }

                .view-btn:hover {
                    background: #138496;
                }

                .refresh-btn {
                    background: #6c757d;
                    color: white;
                    cursor: not-allowed;
                }

                .reports-summary {
                    margin-top: 3rem;
                }

                .reports-summary h2 {
                    color: #333;
                    margin-bottom: 2rem;
                }

                .summary-grid {
                    display: grid;
                    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
                    gap: 1rem;
                }

                .summary-card {
                    background: white;
                    padding: 1.5rem;
                    border-radius: 8px;
                    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
                    border-left: 4px solid #667eea;
                }

                .summary-card h4 {
                    margin: 0 0 0.5rem 0;
                    color: #666;
                    font-size: 0.9rem;
                    text-transform: uppercase;
                    font-weight: 600;
                }

                .summary-number {
                    font-size: 2rem;
                    font-weight: bold;
                    color: #333;
                    margin-bottom: 0.25rem;
                }

                .summary-change {
                    font-size: 0.8rem;
                    font-weight: 600;
                }

                .summary-change.positive {
                    color: #28a745;
                }

                .summary-change.negative {
                    color: #dc3545;
                }

                .page-navigation-header {
                    background: white;
                    border-radius: 8px;
                    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
                    margin-bottom: 2rem;
                    padding: 1rem;
                }

                .nav-header-content {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    flex-wrap: wrap;
                    gap: 1rem;
                }

                .back-to-dashboard {
                    color: #667eea;
                    text-decoration: none;
                    font-weight: 500;
                    padding: 0.5rem 1rem;
                    border-radius: 4px;
                    transition: background 0.3s;
                }

                .back-to-dashboard:hover {
                    background: #f8f9fa;
                }

                .quick-nav {
                    display: flex;
                    gap: 1rem;
                }

                .quick-nav-link {
                    padding: 0.5rem 1rem;
                    color: #666;
                    text-decoration: none;
                    border-radius: 4px;
                    font-weight: 500;
                    transition: all 0.3s;
                }

                .quick-nav-link:hover, .quick-nav-link.active {
                    background: #667eea;
                    color: white;
                }

                @media (max-width: 768px) {
                    .reports-controls {
                        flex-direction: column;
                        align-items: stretch;
                    }

                    .custom-date-range {
                        flex-direction: column;
                        gap: 0.5rem;
                    }

                    .nav-header-content {
                        flex-direction: column;
                        align-items: stretch;
                    }

                    .quick-nav {
                        justify-content: center;
                    }
                }
            `}</style>
        </div>
    );
};

export default Reports;
